export enum DocumentEntity {
  Auth = 'FaxAction Auth',
  Line = 'FaxAction Line',
  None = ''
}
